<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="pop">
    <div class="info">
      <el-scrollbar height="732px">
        <img src="@/assets/pop-title.png" class="popbg" />
        <img src="@/assets/pop-border.png" class="borderleft" />
        <img src="@/assets/pop-border.png" class="borderright" />
        <div class="title">
          大蒜-金蒜5号农事操作记录
          <img src="@/assets/guanbi.png" class="close" @click="close" />
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script setup>
import { defineEmits, onMounted } from "vue";
const emit = defineEmits(["close"]);

const close = () => {
  emit("close");
};
onMounted(() => {});
</script>
<style lang="scss" scoped>
.pop {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba($color: #000000, $alpha: 0.6);
  .info {
    width: 478px;
    height: 675px;
    background: linear-gradient(180deg, #002002 0%, #002603 100%);
    box-shadow: 0px 4px 50px 0px #000000;
    border: 2px solid #055a17;
    margin: 10vh auto;
    display: flex;
    flex-direction: column;
    position: relative;
    color: #fff;
    font-size: 14px;
    .popbg {
      width: 100%;
      height: 50px;
      position: absolute;
      top: 0;
      left: 0;
    }
    .borderleft {
      width: 24px;
      position: absolute;
      left: -1px;
      bottom: -1px;
      transform: rotate(90deg);
    }
    .borderright {
      width: 24px;
      position: absolute;
      bottom: -1px;
      right: -1px;
    }
    .title {
      width: 100%;
      font-size: 28px;
      line-height: 50px;
      letter-spacing: 2px;
      text-shadow: 0px 3px 3px rgba(0, 95, 25, 0.3);
      color: #fff;
      font-family: "YouSheBiaoTiHei";
      padding: 0 16px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1001;
      .close {
        width: 28px;
        height: 28px;
        cursor: pointer;
      }
    }
  }
}
</style>
